import { useEffect, useRef } from 'react';

import { type AdUnitConfiguration } from '~/utils/adUnitSetup';

interface GoogleAdUnitProps {
  adUnitConfiguration: AdUnitConfiguration[];
}

declare global {
  interface Window {
    googletag: any;
  }
}

const GoogleAdUnit = ({ adUnitConfiguration }: GoogleAdUnitProps) => {
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    if (typeof window === 'undefined' || !window.googletag || !adUnitConfiguration?.length) return;

    window.googletag.cmd.push(() => {
      adUnitConfiguration.forEach(({ adUnitCode, dimensions, targetNode, targeting }) => {
        const slot = window.googletag
          .defineSlot(adUnitCode, dimensions, targetNode)
          ?.addService(window.googletag.pubads());

        if (targeting?.position) {
          slot?.setTargeting('position', [targeting.position]);
        }
      });

      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.enableServices();

      adUnitConfiguration.forEach(({ targetNode }) => {
        window.googletag.display(targetNode);
      });
    });

    initRef.current = true;
  }, [adUnitConfiguration]);

  return adUnitConfiguration.map(({ injectOrCreate, targetNode }) =>
    injectOrCreate === 'inject' ? null : <div data-testid={`${targetNode}-testid`} id={targetNode} key={targetNode} />,
  );
};

export default GoogleAdUnit;
